<template>

    <div class="rate">

        <span class="rate-stars">
            <i class="fa-star fa-2x" @mouseover="rateLabel = 1" @mouseleave="rateLabel = rate" v-on:click="changeRate(1)" v-bind:class="[rate > 0 ? 'fas' : 'fal' ]" :data-label="$t('rate.label')"></i>
            <i class="fa-star fa-2x" @mouseover="rateLabel = 2" @mouseleave="rateLabel = rate" v-on:click="changeRate(2)" v-bind:class="[rate > 1 ? 'fas' : 'fal' ]" :data-label="$t('rate.label_bad')"></i>
            <i class="fa-star fa-2x" @mouseover="rateLabel = 3" @mouseleave="rateLabel = rate" v-on:click="changeRate(3)" v-bind:class="[rate > 2 ? 'fas' : 'fal' ]" :data-label="$t('rate.label_poor')"></i>
            <i class="fa-star fa-2x" @mouseover="rateLabel = 4" @mouseleave="rateLabel = rate" v-on:click="changeRate(4)" v-bind:class="[rate > 3 ? 'fas' : 'fal' ]" :data-label="$t('rate.label_fair')"></i>
            <i class="fa-star fa-2x" @mouseover="rateLabel = 5" @mouseleave="rateLabel = rate" v-on:click="changeRate(5)" v-bind:class="[rate > 4 ? 'fas' : 'fal' ]" :data-label="$t('rate.label_good')"></i>
        </span>

        <span class="tag" v-on:click="rateLabel === 0 ? changeRate(5) : ''">
            <span      v-if="rateLabel === 0" v-html="$t('rate.label')"></span>
            <span v-else-if="rateLabel === 1" v-html="$t('rate.label_bad')"></span>
            <span v-else-if="rateLabel === 2" v-html="$t('rate.label_poor')"></span>
            <span v-else-if="rateLabel === 3" v-html="$t('rate.label_fair')"></span>
            <span v-else-if="rateLabel === 4" v-html="$t('rate.label_good')"></span>
            <span v-else-if="rateLabel === 5" v-html="$t('rate.label_excellent')"></span>
        </span>
    </div>

</template>
<style lang="scss">

    $color-black:  #000;
    $color-yellow: #F2C600;

    .form-group label {

        font-weight: 500;
    }

    .rate {

        .rate-stars {

            display: inline-block;
            vertical-align: middle;

            i {
                cursor: pointer;
                color: $color-yellow;
            }
        }

        .tag{

            margin-left: 3em;
            background: $color-yellow;
            color:$color-black;
            height: 35px;
            line-height: 35px;
            display: inline-block;
            padding: 0 20px;
            position: relative;
            cursor:pointer;

            &:before{
                position: absolute;
                top:0;
                left:-15px;
                content: '';
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 18px 15px 18px 0;
                border-color: transparent #f2c600 transparent transparent;
            }
        }
    }

</style>
<script>

    export default {

        props : {
            value: {
                type: Number,
                required : false,
                default : 0,
            },

        },

        data() {

            return {

                rate :     0,
                rateLabel : 0,
            }
        },

        watch : {

        },

        methods: {

            changeRate(value){

                if(this.rate !== value){
                    this.rate = value;
                    this.$emit('on-change', this.rate);
                }
            }
        },

        mounted: function () {

        },

        created: function () {

            this.rateLabel = this.value;
            this.rate      = this.value;
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/rate.vue